// Artwork Submission Page JavaScript
// This file contains JavaScript specific to the public artwork submission page

document.addEventListener('DOMContentLoaded', function() {
  const artistInput = document.getElementById('artist_name');
  const suggestionsDiv = document.getElementById('artist_suggestions');
  const primaryImageInput = document.getElementById('primary_image');
  const primaryImageForm = document.getElementById('primary_image_form');
  const primaryImagePreview = document.getElementById('primary_image_preview');
  const previewImg = document.getElementById('preview_img');
  let searchTimeout;

  // Artist search functionality
  if (artistInput) {
    artistInput.addEventListener('input', function() {
      clearTimeout(searchTimeout);
      const query = this.value.trim();
      
      if (query.length < 2) {
        suggestionsDiv.style.display = 'none';
        return;
      }

      searchTimeout = setTimeout(function() {
        fetch(`/artwork-submissions/search_artists?q=${encodeURIComponent(query)}`)
          .then(response => response.json())
          .then(data => {
            suggestionsDiv.innerHTML = '';
            
            if (data.length > 0) {
              data.forEach(artist => {
                const item = document.createElement('a');
                item.href = '#';
                item.className = 'list-group-item list-group-item-action';
                item.textContent = artist.name;
                item.addEventListener('click', function(e) {
                  e.preventDefault();
                  artistInput.value = artist.name;
                  suggestionsDiv.style.display = 'none';
                });
                suggestionsDiv.appendChild(item);
              });
              suggestionsDiv.style.display = 'block';
            } else {
              suggestionsDiv.style.display = 'none';
            }
          })
          .catch(error => {
            console.error('Error fetching artists:', error);
          });
      }, 300);
    });

    // Hide suggestions when clicking outside
    document.addEventListener('click', function(e) {
      if (!artistInput.contains(e.target) && !suggestionsDiv.contains(e.target)) {
        suggestionsDiv.style.display = 'none';
      }
    });
  }

  // Primary image preview functionality
  if (primaryImageInput) {
    primaryImageInput.addEventListener('change', function() {
      const file = this.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = function(e) {
          previewImg.src = e.target.result;
          primaryImagePreview.style.display = 'block';
        };
        reader.readAsDataURL(file);
        
        // Copy the file to the hidden form input
        if (primaryImageForm) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(file);
          primaryImageForm.files = dataTransfer.files;
        }
      } else {
        primaryImagePreview.style.display = 'none';
        // Clear the hidden form input as well
        if (primaryImageForm) {
          primaryImageForm.value = '';
        }
      }
    });
  }

  // Form validation
  const form = document.querySelector('form');
  if (form) {
    form.addEventListener('submit', function(e) {
      const titleField = document.querySelector('input[name="artwork[title]"]');
      const artworkTypeField = document.querySelector('select[name="artwork[artwork_type]"]');
      
      let isValid = true;
      
      // Clear previous error styling
      document.querySelectorAll('.is-invalid').forEach(field => {
        field.classList.remove('is-invalid');
      });
      
      // Validate title
      if (!titleField.value.trim()) {
        titleField.classList.add('is-invalid');
        isValid = false;
      }
      
      // Validate artwork type
      if (!artworkTypeField.value) {
        artworkTypeField.classList.add('is-invalid');
        isValid = false;
      }
      
      if (!isValid) {
        e.preventDefault();
        
        // Scroll to first error
        const firstError = document.querySelector('.is-invalid');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  }

  // Add visual feedback for form interactions
  const formControls = document.querySelectorAll('.form-control, .form-select');
  formControls.forEach(control => {
    control.addEventListener('focus', function() {
      this.parentElement.classList.add('focused');
    });
    
    control.addEventListener('blur', function() {
      this.parentElement.classList.remove('focused');
    });
  });

  // Auto-resize textareas
  const textareas = document.querySelectorAll('textarea');
  textareas.forEach(textarea => {
    textarea.addEventListener('input', function() {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight + 'px';
    });
  });

  // File size validation
  if (primaryImageInput) {
    primaryImageInput.addEventListener('change', function() {
      const file = this.files[0];
      if (file) {
        const maxSize = 20 * 1024 * 1024; // 20MB
        if (file.size > maxSize) {
          alert('File size must be less than 20MB. Please choose a smaller file.');
          this.value = '';
          primaryImagePreview.style.display = 'none';
          if (primaryImageForm) {
            primaryImageForm.value = '';
          }
        }
      }
    });
  }
}); 